import { useAuthContext } from "../contexts/AuthContextProvider";
import { collectAssignedRoles } from "../config/admin-roles";
import {
    useLocation,
    Navigate,
    Outlet,
} from "react-router-dom";
import { UserType } from "../store/system/types";
import { useMemo } from "react";

export const ProtectedRouter = ({ roles }: { roles: Array<string> }) => {
    const { getUserType, getUserAccount, getUserRoles } = useAuthContext();
    const account = getUserAccount()?.username;
    const location = useLocation();
    return useMemo(() => {
        if (getUserType() !== undefined && getUserType() === UserType.Agent) {
            const currentAccount = getUserAccount();
            const assigned = collectAssignedRoles(
                getUserRoles(),
                currentAccount?.idTokenClaims?.['roles'],
            ).map(role => role.toLowerCase());
            const rolesMatched = roles.filter(role => assigned.includes(role.toLowerCase()));

            if (rolesMatched.length > 0) {
                return <Outlet />;
            }
            return <Navigate to="/un-authorised" state={{ from: location }} replace />;
        }
        return <Outlet />;
    }, [getUserType(), account]);
}